export default __webpack_public_path__ + "static/media/pop_up_trimmed.c11c0c0d.gif";